// This file was auto-generated by querybuilder/Apollo and should not be edited.

import * as ExtendedFormFieldErrors from './ExtendedFormFieldErrors';
import * as AllSessionInfo from './AllSessionInfo';
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { NorentNationalAddressInput, OnboardingInfoSignupIntent, Borough, LeaseType, LetterRequestMailChoice, CustomIssueArea, HPUploadStatus, HPDocusignStatus, PhoneNumberAccountStatus } from "./globalTypes";

// ====================================================
// GraphQL mutation operation: NorentNationalAddressMutation
// ====================================================

export interface NorentNationalAddressMutation_output_errors_extendedMessages {
  /**
   * A human-readable validation error.
   */
  message: string;
  /**
   * A machine-readable representation of the error.
   */
  code: string | null;
}

export interface NorentNationalAddressMutation_output_errors {
  /**
   * The camel-cased name of the input field, or '__all__' for non-field errors.
   */
  field: string;
  /**
   * A list of validation errors with extended metadata.
   */
  extendedMessages: NorentNationalAddressMutation_output_errors_extendedMessages[];
}

export interface NorentNationalAddressMutation_output_session_rentStabInfo {
  /**
   * The last year that the user's building had rent stabilized units. If null, no
   * units were found since 2007. Note: this will never be the empty string. 
   */
  latestYear: string | null;
  /**
   * The most recent count of rent stabilized units in user's building. If null, no units were found since 2007.
   */
  latestUnitCount: number | null;
}

export interface NorentNationalAddressMutation_output_session_activePartnerReferral {
  /**
   * The name of the partner organization.
   */
  name: string;
  /**
   * The short identifier for the partner organization.
   */
  slug: string;
  /**
   * The primary website of the partner organization.
   */
  website: string;
}

export interface NorentNationalAddressMutation_output_session_onboardingScaffolding {
  firstName: string;
  lastName: string;
  preferredFirstName: string;
  street: string;
  city: string;
  isCityInNyc: boolean | null;
  /**
   * Whether the onboarding user is in Los Angeles County. If we don't have enough information to tell, this will be null.
   */
  isInLosAngeles: boolean | null;
  state: string;
  borough: string;
  zipCode: string;
  aptNumber: string | null;
  email: string;
  phoneNumber: string;
  leaseType: string;
  receivesPublicAssistance: boolean | null;
  hasLandlordEmailAddress: boolean | null;
  hasLandlordMailingAddress: boolean | null;
  canReceiveRttcComms: boolean | null;
  canReceiveSajeComms: boolean | null;
}

export interface NorentNationalAddressMutation_output_session_onboardingInfo {
  /**
   * The reason the user originally signed up with us.
   */
  signupIntent: OnboardingInfoSignupIntent;
  /**
   * The user's address. Only street name and number are required.
   */
  address: string;
  /**
   * The non-NYC city the user's address is in, if they live outside of NYC.
   */
  nonNycCity: string;
  /**
   * The user's ZIP code. This field is automatically updated for NYC users when you change the address or borough.
   */
  zipcode: string;
  /**
   * The user's Boro, Block, and Lot number. This field is automatically updated
   * for NYC users when you change the address or borough.
   */
  padBbl: string;
  aptNumber: string;
  /**
   * The floor number the user's apartment is on.
   */
  floorNumber: number | null;
  /**
   * Has the user called 311 before?
   */
  hasCalled311: boolean | null;
  /**
   * Does the user receive public assistance, e.g. Section 8?
   */
  receivesPublicAssistance: boolean | null;
  /**
   * Whether the user has agreed to the JustFix.nyc terms of service and privacy policy.
   */
  agreedToJustfixTerms: boolean;
  /**
   * Whether the user has agreed to the NoRent.org terms of service and privacy policy.
   */
  agreedToNorentTerms: boolean;
  /**
   * Whether the user has agreed to the Eviction Free terms of service and privacy policy.
   */
  agreedToEvictionfreeTerms: boolean;
  /**
   * Whether the user has agreed to the LA Letter Builder terms of service and privacy policy.
   */
  agreedToLaletterbuilderTerms: boolean;
  /**
   * Whether the user has opted-in to being contacted by the Right to the City Alliance (RTTC).
   */
  canReceiveRttcComms: boolean | null;
  /**
   * Whether the user has opted-in to being contacted by Strategic Actions for a Just Economy (SAJE).
   */
  canReceiveSajeComms: boolean | null;
  /**
   * The New York City borough the user's address is in, if they live inside NYC.
   */
  borough: Borough | null;
  /**
   * The type of housing the user lives in (NYC only).
   */
  leaseType: LeaseType | null;
  /**
   * The two-letter state or territory of the user, e.g. "NY".
   */
  state: string;
  /**
   * The city of the user. For NYC-based users, this will be the same as
   *         the borough name, except we use "New York" instead of "Manhattan".
   */
  city: string;
  /**
   * Whether the user is in Los Angeles County. If we don't have enough information to tell, this will be null.
   */
  isInLosAngeles: boolean | null;
  /**
   * The user's full mailing address, as it will appear on mailings and other official documents.
   */
  fullMailingAddress: string;
  /**
   * The county of the user's address, or null if we don't know.
   */
  county: string | null;
}

export interface NorentNationalAddressMutation_output_session_norentAvailableRentPeriods {
  /**
   * The date rent payment is due.
   */
  paymentDate: GraphQLDate;
}

export interface NorentNationalAddressMutation_output_session_norentLatestLetter {
  createdAt: GraphQLDateTime;
  /**
   * The USPS tracking number for the mail item.
   */
  trackingNumber: string;
  /**
   * When the letter was mailed.
   */
  letterSentAt: GraphQLDateTime | null;
}

export interface NorentNationalAddressMutation_output_session_landlordDetails {
  /**
   * Usually the first line of the address, e.g. "150 Court Street"
   */
  primaryLine: string;
  /**
   * The city of the address, e.g. "Brooklyn".
   */
  city: string;
  /**
   * The zip code of the address, e.g. "11201" or "94107-2282".
   */
  zipCode: string;
  /**
   * The landlord's name.
   */
  name: string;
  /**
   * The landlord's email address.
   */
  email: string;
  /**
   * A U.S. phone number without parentheses or hyphens, e.g. "5551234567".
   */
  phoneNumber: string;
  /**
   * Whether the name and address was looked up automatically, or manually entered by the user.
   */
  isLookedUp: boolean;
  /**
   * The full mailing address of the user, as a single string. Note that this may
   * actually be populated even if individual address fields are empty; this
   * represents legacy data created before we split up addresses into individual fields.
   */
  address: string;
  state: string;
}

export interface NorentNationalAddressMutation_output_session_letterRequest {
  /**
   * How the letter of complaint will be mailed.
   */
  mailChoice: LetterRequestMailChoice;
  /**
   * The tracking number for the letter. Note that when this is changed, the user
   * will be notified via SMS and added to a LOC follow-up campaign, if one has
   * been configured.
   */
  trackingNumber: string;
  /**
   * When the letter was mailed through the postal service.
   */
  letterSentAt: GraphQLDateTime | null;
  updatedAt: GraphQLDateTime;
}

export interface NorentNationalAddressMutation_output_session_customIssuesV2 {
  id: string;
  /**
   * The area this custom issue belongs to.
   */
  area: CustomIssueArea;
  /**
   * The description of this custom issue.
   */
  description: string;
}

export interface NorentNationalAddressMutation_output_session_feeWaiver {
  /**
   * Whether the user receives any kind of public assistance benefits, e.g. cash
   * benefits, rent assistance, food stamps, Medicaid.
   */
  receivesPublicAssistance: boolean | null;
  /**
   * The amount of income the user receives per month.
   */
  incomeAmountMonthly: GraphQLDecimal | null;
  /**
   * Whether the user receives income from employment.
   */
  incomeSrcEmployment: boolean;
  /**
   * Whether the user receives income from the Human Resources Administration (e.g., Temporary Aid to Needy Families).
   */
  incomeSrcHra: boolean;
  /**
   * Whether the user receives income from child support.
   */
  incomeSrcChildSupport: boolean;
  /**
   * Whether the user receives income from alimony.
   */
  incomeSrcAlimony: boolean;
  /**
   * Whether the user receives income from social security.
   */
  incomeSrcSocialSecurity: boolean;
  /**
   * Other income the user receives
   */
  incomeSrcOther: string;
  /**
   * The amount of money the user pays in rent per month.
   */
  rentAmount: GraphQLDecimal | null;
  expenseUtilities: GraphQLDecimal;
  expenseCable: GraphQLDecimal;
  expensePhone: GraphQLDecimal;
  expenseChildcare: GraphQLDecimal;
  expenseOther: GraphQLDecimal;
  /**
   * Whether the user has requested a fee waiver before.
   */
  askedBefore: boolean | null;
}

export interface NorentNationalAddressMutation_output_session_hpActionDetails {
  /**
   * Whether the user wants to sue for repairs.
   */
  sueForRepairs: boolean | null;
  /**
   * Whether the user wants to sue for harassment.
   */
  sueForHarassment: boolean | null;
  /**
   * Whether the user has filed any complaints with 311 before.
   */
  filedWith311: boolean | null;
  /**
   * Whether 30 days have passed since the user filed complaints with 311.
   */
  thirtyDaysSince311: boolean | null;
  /**
   * Whether HPD issued any violations.
   */
  hpdIssuedViolations: boolean | null;
  /**
   * Whether 30 days have passed since HPD issued violations.
   */
  thirtyDaysSinceViolations: boolean | null;
  /**
   * Whether the conditions are urgent and dangerous.
   */
  urgentAndDangerous: boolean | null;
}

export interface NorentNationalAddressMutation_output_session_harassmentDetails {
  /**
   * Does you building have 2 apartments or less?
   */
  twoOrLessApartmentsInBuilding: boolean | null;
  /**
   * Is there more than one family living in each apartment?
   */
  moreThanOneFamilyPerApartment: boolean | null;
  /**
   * Explain how the landlord has harassed you.
   */
  harassmentDetails: string;
  /**
   * Whether the tenant alleges the landlord has FORCE.
   */
  allegForce: boolean;
  /**
   * Whether the tenant alleges the landlord has MISLEADING_INFO.
   */
  allegMisleadingInfo: boolean;
  /**
   * Whether the tenant alleges the landlord has STOPPED_SERVICE.
   */
  allegStoppedService: boolean;
  /**
   * Whether the tenant alleges the landlord has FAILED_TO_COMPLY.
   */
  allegFailedToComply: boolean;
  /**
   * Whether the tenant alleges the landlord has FALSE_CERT_REPAIRS.
   */
  allegFalseCertRepairs: boolean;
  /**
   * Whether the tenant alleges the landlord has CONDUCT_IN_VIOLATION.
   */
  allegConductInViolation: boolean;
  /**
   * Whether the tenant alleges the landlord has SUED.
   */
  allegSued: boolean;
  /**
   * Whether the tenant alleges the landlord has REMOVED_POSSESSIONS.
   */
  allegRemovedPossessions: boolean;
  /**
   * Whether the tenant alleges the landlord has INDUCED_LEAVING.
   */
  allegInducedLeaving: boolean;
  /**
   * Whether the tenant alleges the landlord has CONTACT.
   */
  allegContact: boolean;
  /**
   * Whether the tenant alleges the landlord has THREATS_RE_STATUS.
   */
  allegThreatsReStatus: boolean;
  /**
   * Whether the tenant alleges the landlord has REQUESTED_ID.
   */
  allegRequestedId: boolean;
  /**
   * Whether the tenant alleges the landlord has DISTURBED.
   */
  allegDisturbed: boolean;
}

export interface NorentNationalAddressMutation_output_session_managementCompanyDetails {
  /**
   * The name of the receipient at the address.
   */
  name: string;
  /**
   * Usually the first line of the address, e.g. "150 Court Street"
   */
  primaryLine: string;
  /**
   * The city of the address, e.g. "Brooklyn".
   */
  city: string;
  /**
   * The two-letter state or territory for the address, e.g. "NY".
   */
  state: string;
  /**
   * The zip code of the address, e.g. "11201" or "94107-2282".
   */
  zipCode: string;
}

export interface NorentNationalAddressMutation_output_session_tenantChildren {
  id: string;
  /**
   * The child's name.
   */
  name: string;
  /**
   * The child's date of birth.
   */
  dob: GraphQLDate;
}

export interface NorentNationalAddressMutation_output_session_priorHpActionCases {
  id: string;
  /**
   * The court case number (also known as the "index number").
   */
  caseNumber: string;
  /**
   * The date of the case.
   */
  caseDate: GraphQLDate;
  /**
   * Whether this is a harassment case.
   */
  isHarassment: boolean;
  /**
   * Whether this is a repairs case.
   */
  isRepairs: boolean;
}

export interface NorentNationalAddressMutation_output_session_hardshipDeclarationDetails {
  /**
   * The user's existing eviction case index number, if any.
   */
  indexNumber: string;
  /**
   * The court the user's existing eviction case is at, if any.
   */
  courtName: string;
  /**
   * Whether the user has COVID-19 related financial hardship.
   */
  hasFinancialHardship: boolean;
  /**
   * Whether the user has COVID-19 related heath risk.
   */
  hasHealthRisk: boolean;
}

export interface NorentNationalAddressMutation_output_session_submittedHardshipDeclaration {
  createdAt: GraphQLDateTime;
  /**
   * The USPS tracking number for the mail item.
   */
  trackingNumber: string;
  /**
   * When the declaration was mailed to the user's landlord.
   */
  mailedAt: GraphQLDateTime | null;
  /**
   * When the declaration was e-mailed to the user's landlord.
   */
  emailedAt: GraphQLDateTime | null;
  /**
   * When the declaration was e-mailed to the user's housing court.
   */
  emailedToHousingCourtAt: GraphQLDateTime | null;
  /**
   * When the declaration was e-mailed to the user.
   */
  emailedToUserAt: GraphQLDateTime | null;
}

export interface NorentNationalAddressMutation_output_session {
  /**
   * The name of the staff member who is impersonating the current user. If the
   * current user isn't being impersonated by anyone, this will be null.
   */
  impersonatedBy: string | null;
  rentStabInfo: NorentNationalAddressMutation_output_session_rentStabInfo | null;
  activePartnerReferral: NorentNationalAddressMutation_output_session_activePartnerReferral | null;
  onboardingScaffolding: NorentNationalAddressMutation_output_session_onboardingScaffolding | null;
  /**
   * The user's onboarding details, which they filled out during the onboarding
   * process. This is not to be confused with the individual onboarding steps,
   * which capture information someone filled out *during* onboarding, before they
   * became a full-fledged user.
   */
  onboardingInfo: NorentNationalAddressMutation_output_session_onboardingInfo | null;
  /**
   * A list of the available rent periods the current user can create a no rent letter for.
   */
  norentAvailableRentPeriods: NorentNationalAddressMutation_output_session_norentAvailableRentPeriods[];
  /**
   * The latest no rent letter sent by the user. If the user has never sent a letter or is not logged in, this will be null.
   */
  norentLatestLetter: NorentNationalAddressMutation_output_session_norentLatestLetter | null;
  /**
   * The number of no rent letters sent by the whole platform (not just the current user).
   */
  norentLettersSent: number;
  /**
   * The rent periods that the user's upcoming no rent letter are in regards to.
   */
  norentUpcomingLetterRentPeriods: GraphQLDate[];
  accessDates: string[];
  landlordDetails: NorentNationalAddressMutation_output_session_landlordDetails | null;
  letterRequest: NorentNationalAddressMutation_output_session_letterRequest | null;
  issues: string[];
  customIssuesV2: NorentNationalAddressMutation_output_session_customIssuesV2[] | null;
  feeWaiver: NorentNationalAddressMutation_output_session_feeWaiver | null;
  hpActionDetails: NorentNationalAddressMutation_output_session_hpActionDetails | null;
  harassmentDetails: NorentNationalAddressMutation_output_session_harassmentDetails | null;
  /**
   * Manually-specified details about the user's management company. Will only be
   * non-blank if the user provided these details themselves (i.e., did not elect
   * to use our recommended details from open data).
   */
  managementCompanyDetails: NorentNationalAddressMutation_output_session_managementCompanyDetails | null;
  /**
   * The URL of the most recently-generated Normal HP Action PDF for the current user.
   */
  latestHpActionPdfUrl: string | null;
  /**
   * The status of the Normal HP Action upload (document assembly) process for a user.
   */
  hpActionUploadStatus: HPUploadStatus;
  /**
   * The URL of the most recently-generated Emergency HP Action (COVID-19) PDF for the current user.
   */
  latestEmergencyHpActionPdfUrl: string | null;
  /**
   * The status of the Emergency HP Action (COVID-19) upload (document assembly) process for a user.
   */
  emergencyHpActionUploadStatus: HPUploadStatus;
  /**
   * The DocuSign signing status of the user's Emergency HP Action. If the signing
   * process has not yet begun, this will be null.
   */
  emergencyHpActionSigningStatus: HPDocusignStatus | null;
  tenantChildren: NorentNationalAddressMutation_output_session_tenantChildren[] | null;
  priorHpActionCases: NorentNationalAddressMutation_output_session_priorHpActionCases[] | null;
  hardshipDeclarationDetails: NorentNationalAddressMutation_output_session_hardshipDeclarationDetails | null;
  submittedHardshipDeclaration: NorentNationalAddressMutation_output_session_submittedHardshipDeclaration | null;
  /**
   * The ID of the currently logged-in user, or null if not logged-in.
   */
  userId: number | null;
  /**
   * The first name of the currently logged-in user, or null if not logged-in.
   */
  firstName: string | null;
  /**
   * The last name of the currently logged-in user, or null if not logged-in.
   */
  lastName: string | null;
  /**
   * The preferred first name of the currently logged-in user, or null if not logged-in.
   */
  preferredFirstName: string | null;
  /**
   * The phone number of the currently logged-in user, or null if not logged-in.
   */
  phoneNumber: string | null;
  /**
   * The phone number most recently queried, or null if none.
   */
  lastQueriedPhoneNumber: string | null;
  /**
   * The account status of the phone number most recently queried, or null if none.
   */
  lastQueriedPhoneNumberAccountStatus: PhoneNumberAccountStatus | null;
  /**
   * The email of the currently logged-in user, or null if not logged-in. Note that
   * this can be an empty string if the user hasn't yet given us their email.
   */
  email: string | null;
  /**
   * Whether the user's email address has been verified, or null if not logged-in.
   */
  isEmailVerified: boolean | null;
  /**
   * The cross-site request forgery (CSRF) token.
   */
  csrfToken: string;
  /**
   * Whether or not the currently logged-in user is a staff member.
   */
  isStaff: boolean;
  /**
   * Whether or not the current session has safe/compatibility mode compatibility mode) enabled.
   */
  isSafeModeEnabled: boolean;
}

export interface NorentNationalAddressMutation_output {
  /**
   * A list of validation errors in the form, if any. If the form was valid, this list will be empty.
   */
  errors: NorentNationalAddressMutation_output_errors[];
  session: NorentNationalAddressMutation_output_session | null;
  /**
   * Whether or not the provided address appears to be valid. If Mapbox integration
   * is disabled, there was a problem contacting Mapbox, or the mutation was
   * unsuccessful, this will be null.
   */
  isValid: boolean | null;
}

export interface NorentNationalAddressMutation {
  output: NorentNationalAddressMutation_output;
}

export interface NorentNationalAddressMutationVariables {
  input: NorentNationalAddressInput;
}

export const BlankNorentNationalAddressInput: NorentNationalAddressInput = {
  "aptNumber": "",
  "noAptNumber": false,
  "street": "",
  "zipCode": ""
};

export const NorentNationalAddressMutation = {
  // The following query was taken from NorentNationalAddressMutation.graphql.
  graphQL: `# This file was auto-generated by querybuilder, please do not edit it.
mutation NorentNationalAddressMutation($input: NorentNationalAddressInput!) {
  output: norentNationalAddress(input: $input) {
    errors { ...ExtendedFormFieldErrors },
    session { ...AllSessionInfo },
    isValid
  }
}
${ExtendedFormFieldErrors.graphQL}
${AllSessionInfo.graphQL}`,
  name: "NorentNationalAddressMutation",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, args: NorentNationalAddressMutationVariables): Promise<NorentNationalAddressMutation> {
    return fetchGraphQL(NorentNationalAddressMutation.graphQL, args);
  },
  blankInput: BlankNorentNationalAddressInput,
};

export const fetchNorentNationalAddressMutation = NorentNationalAddressMutation.fetch;